import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React, { Component } from 'react';
import ClampLines from 'react-clamp-lines';
import { connect } from 'react-redux';
import AddMembers from './AddMembers/AddMembers';
import LogCard from './LogCard/LogCard';
import classes from './ManageLogs.module.css';
import Spinner from 'components/UI/Spinner/Spinner';
import { arraysEqual, checkValidity, sortLogNamesForDisplay, updateObject, updatedControlsForInput } from 'shared/utility';
import * as actions from 'store/actions';
import { fetchUserProfile } from 'store/thunks';

class ManageLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: {
        logName: {
          elementType: 'input',
          elementConfig: {
            type: 'input',
            placeholder: 'Enter log name',
          },
          value: '',
          validation: {
            required: true,
            validationError: 'Please enter a log name',
          },
        },
      },
      formIsValid: false,
      formTouched: false,
      showCreateLogForm: false,
      showLogInvite: false,
      showRemoveSelfFromLogConfirmation: false,
      showRemoveUserFromLogConfirmation: false,
      showLogDeletionConfirmation: false,
      showLogUserRemovalConfirmation: false,
      showLogUserArchiveConfirmation: false,
      showAddMembers: false,
      selectedLogId: null,
      submitted: false,
    };
  }

  componentDidMount() {
    if (this.props.postingAs.Logs) {
      this.handleLogsFetch();
      this.setInitiallySelectedLog();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.submitted && !prevProps.submitted) {
      this.setState({ submitted: true });
    }
    if (this.props.postingAs.Logs !== prevProps.postingAs.Logs) {
      this.handleLogsFetch();
    }

    if (this.props.logs !== prevProps.logs && prevProps.logs) {
      let prevLogIds = prevProps.logs.map((log) => log.Log.Id).sort();
      const currentLogIds = this.props.logs.map((log) => log.Log.Id).sort();
      const logIdsHaveChanged = !arraysEqual(prevLogIds, currentLogIds);
      // const postingAsSameAsSignedInAs = this.props.postingAs.UserId === this.props.signedInAs.UserId;
      // Update selectedLogId when a new log is added or a log is deleted
      if (logIdsHaveChanged) {
        if (!this.state.submitted) {
          this.setInitiallySelectedLog();
          this.setState({ showAddMembers: false });
        } else if (this.props.logs && this.props.logs.length > prevProps.logs.length) {
          prevLogIds = prevProps.logs ? prevProps.logs.map((log) => log.Log.Id) : [];
          const updatedLogIds = this.props.logs.map((log) => log.Log.Id);
          const newlyCreatedLog = updatedLogIds.filter((logId) => !prevLogIds.includes(logId))[0];

          this.setState({ submitted: false, selectedLogId: newlyCreatedLog, showAddMembers: false });
        }
      }
    }
  }

  setInitiallySelectedLog = (isResetting) => {
    if (this.props.postingAs.Logs.length > 0) {
      const selectedLog =
        [...this.props.postingAs.Logs].filter((log) => log.Visibility === 'Private').length > 0
          ? [...this.props.postingAs.Logs].filter((log) => log.Visibility === 'Private')[0]
          : [...this.props.postingAs.Logs][0];
      this.handleLogSelect(selectedLog.Id, isResetting);
    }
  };

  handleLogsFetch = () => {
    const userId = this.props.isManagedUser ? this.props.postingAs.UserId : null;
    this.props.onFetchLogsDetails(userId, this.props.isManagedUser);
  };

  inputChangedHandler = (event, controlName) => {
    const updatedControls = updatedControlsForInput(event.target.value, controlName, this.state.controls);
    const formIsValid = event.target.value.length > 0;
    this.setState({ controls: updatedControls, formIsValid });
  };

  handleLogCreation = () => {
    this.props.onCreateLog(this.state.controls.logName.value, 'InviteOnly', this.props.postingAs.UserId, this.props.isManagedUser);
    this.handleLogFormReset();
  };

  handleLogUpdate = (logId, name, deleting) => {
    this.props.onLogUpdate(logId, name, deleting, this.props.postingAs.UserId, this.props.isManagedUser);
  };

  handleLogNameUpdate = (logId, name) => {
    this.handleLogUpdate(logId, name, false);
  };

  handleLogFormReset = (highlightPrivateLog) => {
    const updatedControls = updateObject(this.state.controls, {
      logName: updateObject(this.state.controls.logName, {
        value: '',
        valid: checkValidity('logName', this.state.controls.logName.validation),
        touched: false,
      }),
      members: [],
    });
    if (highlightPrivateLog) this.setInitiallySelectedLog(true);
    this.setState({ controls: updatedControls, showCreateLogForm: false, formIsValid: false, formIsTouched: false });
  };

  toggleComponent = (componentName) => {
    this.setState({ [componentName]: !this.state[componentName] });
  };

  handleLogSelect = (logId, isResetting) => {
    this.setState({ selectedLogId: logId });
    if (this.state.showCreateLogForm && isResetting !== true) this.handleLogFormReset(false);
  };

  // handleLogUpdate(logId, name, deleting) {
  //   this.props.onLogUpdate(logId, name, deleting, this.props.postingAs.UserId, this.props.isManagedUser);
  // }

  handleLogDeletion = (logId) => {
    this.handleLogUpdate(logId, null, true);
    this.setInitiallySelectedLog();
    this.setState({ showLogEdit: false, showLogDeletionConfirmation: false, currentlyUpdatingLog: null });
  };

  showLogCreationForm = () => {
    this.toggleComponent('showCreateLogForm');
    const postingAsUser = {
      FirstName: this.props.postingAs.FirstName,
      LastName: this.props.postingAs.LastName,
      Color: this.props.postingAs.Color,
      ThumbURL: _get(this.props, 'postingAs.ImageURL', _get(this.props, 'postingAs.ThumbURL')),
      UserId: this.props.postingAs.UserId,
      Access: 'Host',
    };
    const updatedControls = updateObject(this.state.controls, {
      members: [postingAsUser],
    });
    this.setState({ selectedLogId: null, controls: updatedControls });
  };

  handleRemoveUserFromLog = (logId, removedUserId, isManagedUser, userId, removeUserAndContent) => {
    const isSelf = userId === this.props.postingAs.UserId;
    this.props.onLogLeave(logId, [removedUserId], isManagedUser, userId, isSelf, removeUserAndContent);
    this.setState({ showRemoveUserFromLogConfirmation: false });
  };

  toggleLogInvite = (log) => {
    this.toggleComponent('showLogInvite');
    this.setState({ currentlyUpdatingLog: log });
  };

  handleLogAddRemoveMembers = (logId, inviteUserIds, inviteUserEmails, customInviteMessage, removeUsersIds, keepPosts) => {
    this.props.onLogAddRemoveMembers(
      logId,
      inviteUserIds,
      inviteUserEmails,
      removeUsersIds,
      customInviteMessage,
      this.props.isManagedUser,
      this.props.postingAs.UserId,
      keepPosts,
    );
    this.toggleComponent('showLogInvite');
  };

  handleLogRemoveArchivedMember = (logId, removedMemberIds) => {
    this.props.onLogRemoveArchivedUsers(logId, removedMemberIds, this.props.isManagedUser, this.props.postingAs.UserId);
  };

  handleLogInviteNewUser = (logId, name, email, mobileNumber, inviteMessage) => {
    this.props.onLogInviteNewUsers(logId, name, email, mobileNumber, inviteMessage, this.props.isManagedUser, this.props.postingAs.UserId);
    this.toggleComponent('showLogInvite');
  };

  toggleAddMembers = () => {
    this.setState({ showAddMembers: !this.state.showAddMembers });
  };

  handleLogMemberAccessUpdate = (logId, forUserId, accessLevel) => {
    this.props.onLogUpdateUserAccess(logId, forUserId, accessLevel, this.props.postingAs.UserId, this.props.isManagedUser);
  };

  handleLogTransferHost = (logId, forUserId) => {
    this.props.onLogTransferHost(logId, forUserId, this.props.postingAs.UserId, this.props.isManagedUser);
  };

  render = () => {
    let addMembers = null;
    const sortedLogs = this.props.postingAs.Logs ? sortLogNamesForDisplay([...this.props.postingAs.Logs]) : [];
    const selectedLog =
      this.props.logs && this.state.selectedLogId && this.props.logs.find((log) => log.Log.Id === this.state.selectedLogId)
        ? this.props.logs.find((log) => log.Log.Id === this.state.selectedLogId)
        : null;

    const userLogRole =
      selectedLog && this.props.postingAs && selectedLog.Users.find((member) => member.UserId === this.props.postingAs.UserId)
        ? selectedLog.Users.find((member) => member.UserId === this.props.postingAs.UserId).Access
        : null;
    const logsList = sortedLogs.map((log, i) => {
      const logListItemClasses = log.Id === this.state.selectedLogId ? [classes.LogListItem, classes.Selected].join(' ') : classes.LogListItem;
      if (this.state.showAddMembers === true && selectedLog) {
        addMembers = (
          <AddMembers
            show
            cancel={this.toggleAddMembers}
            handleLogAddRemoveMembers={this.handleLogAddRemoveMembers}
            handleLogInviteNewUser={this.handleLogInviteNewUser}
            handleManagedAccountCreation={this.handleManagedAccountCreation}
            log={selectedLog}
            existingMembers={this.state.showCreateLogForm ? this.state.controls.members : selectedLog ? selectedLog.Users : []}
            postingAs={this.props.postingAs}
            isManagedUser={this.props.isManagedUser}
          />
        );
      }
      return (
        <div id={log.Id} key={i} className={logListItemClasses} onClick={() => this.handleLogSelect(log.Id)}>
          <ClampLines id={log.Id} text={log.Name} buttons={false} lines={1} ellipsis="..." className={classes.LogName} />
        </div>
      );
    });

    const selectedLogBottomBorder = document.getElementById('selected-log-border-bottom');

    if (this.state.selectedLogId !== null || this.state.showCreateLogForm) {
      if (this.state.showCreateLogForm) {
        const logsListElement = document.getElementById('logs-list');
        const selectedLogBottom = `${logsListElement.offsetTop + logsListElement.offsetHeight + 69}px`;

        selectedLogBottomBorder.style.top = selectedLogBottom;
      } else if (selectedLog) {
        const selectedLogBottom = `${_get(document.getElementById(selectedLog.Log.Id), 'offsetTop', 0) + 44}px`;
        selectedLogBottomBorder.style.top = selectedLogBottom;
      }
    }

    return (
      <div className={classes.ManageLogsContainer}>
        <div className={classes.LeftColumn}>
          <h2 className={classes.PageTitle}>Logs</h2>
          <div
            style={{ top: '222px', visibility: this.props.logs && this.props.logs.length > 0 ? 'visible' : 'hidden' }}
            id="selected-log-border-bottom"
            className={classes.SelectedLogBottomBorder}
          />
          <div className={classes.LogsList} id="logs-list">
            {logsList}
          </div>
          <div className={classes.AddLogForm}>
            {this.state.showCreateLogForm ? (
              <div>
                <input
                  id="add-log-input"
                  className={classes.AddLogInput}
                  value={this.state.controls.logName.value}
                  placeholder={this.state.controls.logName.elementConfig.placeholder}
                  onChange={(event) => this.inputChangedHandler(event, 'logName')}
                />
                <div className={classes.AddLogFormActions}>
                  <button
                    className={this.state.formIsValid ? classes.SubmitLog : [classes.SubmitLog, classes.Disabled].join(' ')}
                    onClick={this.state.formIsValid ? this.handleLogCreation : undefined}
                  >
                    Save
                  </button>
                  <button onClick={() => this.handleLogFormReset(true)} className={classes.CancelButton}>
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <button className={classes.AddLogButton} onClick={this.showLogCreationForm}>
                <FontAwesomeIcon className={classes.AddLogButtonIcon} icon="plus" /> New Log
              </button>
            )}
          </div>
        </div>
        <div className={classes.RightColumn}>
          {this.props.logs.length === 0 ? (
            <Spinner lightColor small />
          ) : (
            <div>
              <LogCard
                log={this.state.showCreateLogForm ? { Log: { Name: this.state.controls.logName.value } } : selectedLog}
                members={this.state.showCreateLogForm ? this.state.controls.members : selectedLog ? selectedLog.Users : []}
                created={!this.state.showCreateLogForm}
                isManagedUser={this.props.isManagedUser}
                postingAs={this.props.postingAs}
                error={this.props.error}
                addMembersVisible={this.state.showAddMembers}
                handleLogCreation={this.handleLogCreation}
                handleLogDeletion={this.handleLogDeletion}
                handleLogNameUpdate={this.handleLogNameUpdate}
                handleLogAddRemoveMembers={this.handleLogAddRemoveMembers}
                handleLogRemoveArchivedMember={this.handleLogRemoveArchivedMember}
                handleLogMemberAccessUpdate={this.handleLogMemberAccessUpdate}
                handleLogTransferHost={this.handleLogTransferHost}
                handleAddMembersToggle={() => this.toggleComponent('showAddMembers')}
              />
              {!this.state.showAddMembers && ['Host', 'Co-host', 'Member+'].includes(userLogRole) && selectedLog.Log.Visibility !== 'Private' ? (
                <p className={classes.AddMembersLink} onClick={this.toggleAddMembers}>
                  + Members
                </p>
              ) : null}
              {addMembers}
            </div>
          )}
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    signedInAs: state.user.signedInAs,
    postingAs: state.user.postingAs,
    isManagedUser: state.user.signedInAs.UserId !== state.user.postingAs.UserId,
    error: state.user.error,
    loading: state.user.loading,
    logs: state.logs.LogsDetails,
    submitted: state.logs.submitted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCreateLog: (name, visibility, userId, isManagedUser) => dispatch(actions.createLog(name, visibility, userId, isManagedUser)),
    onFetchUserProfile: (UserId, isManagedUser, userStatus, postingAsSameAsSignedInAs) =>
      dispatch(fetchUserProfile(UserId, isManagedUser, userStatus, postingAsSameAsSignedInAs)),
    onFetchLogsDetails: (userId, isManagedUser) => dispatch(actions.fetchLogsDetails(userId, isManagedUser)),
    onLogAddRemoveMembers: (LogId, InviteUsersIds, InviteUsersEmails, RemoveUsersIds, InviteMessage, isManagedUser, UserId, KeepPosts) =>
      dispatch(
        actions.logAddRemoveMembers(LogId, InviteUsersIds, InviteUsersEmails, RemoveUsersIds, InviteMessage, isManagedUser, UserId, KeepPosts),
      ),
    onLogRemoveArchivedUsers: (LogId, RemoveUserIds, isManagedUser, UserId) =>
      dispatch(actions.logRemoveArchivedUsers(LogId, RemoveUserIds, isManagedUser, UserId)),
    onLogInviteNewUsers: (LogId, Name, Email, MobileNumber, InviteMessage, isManagedUser, UserId) =>
      dispatch(actions.logInviteNewUsers(LogId, Name, Email, MobileNumber, InviteMessage, isManagedUser, UserId)),
    onLogLeave: (logId, RemoveUsersIds, isManagedUser, UserId, isSelf) =>
      dispatch(actions.logLeave(logId, RemoveUsersIds, isManagedUser, UserId, isSelf)),
    onLogUpdate: (logId, name, deleting, postingAsUserId, isManagedUser) =>
      dispatch(actions.logUpdate(logId, name, deleting, postingAsUserId, isManagedUser)),
    onLogUpdateUserAccess: (LogId, ForUserId, Access, UserId, isManagedUser) =>
      dispatch(actions.logUpdateUserAccess(LogId, ForUserId, Access, UserId, isManagedUser)),
    onLogTransferHost: (LogId, ToUserId, UserId, isManagedUser) => dispatch(actions.logTransferHost(LogId, ToUserId, UserId, isManagedUser)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageLogs);
